/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "@angular/core";
import * as i1 from "./loader.component";
var styles_Loader = [];
var RenderType_Loader = i0.ɵcrt({ encapsulation: 2, styles: styles_Loader, data: {} });
export { RenderType_Loader as RenderType_Loader };
export function View_Loader_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, 0, null, null, 2, "div", [["class", "w-100 float-left min-h2 relative"]], null, null, null, null, null)), (_l()(), i0.ɵeld(1, 0, null, null, 1, "div", [["style", "position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%); text-align: center"]], null, null, null, null, null)), (_l()(), i0.ɵeld(2, 0, null, null, 0, "img", [["alt", "loading"], ["src", "./assets/img/load.gif"], ["width", "80px"]], null, null, null, null, null))], null, null); }
export function View_Loader_Host_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, 0, null, null, 1, "loader", [], null, null, null, View_Loader_0, RenderType_Loader)), i0.ɵdid(1, 49152, null, 0, i1.Loader, [], null, null)], null, null); }
var LoaderNgFactory = i0.ɵccf("loader", i1.Loader, View_Loader_Host_0, {}, {}, []);
export { LoaderNgFactory as LoaderNgFactory };



// WEBPACK FOOTER //
// ./src/app/bi/admin/controller/loader.component.ngfactory.js.pre-build-optimizer.js